import {
  Button,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  TextField,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { DataGrid } from "@mui/x-data-grid";
import Paper from "@mui/material/Paper";
import FilterListIcon from "@mui/icons-material/FilterList";
import AddPhoto from "../../assets/svg/AddPhoto.svg";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import {
  ArrowForwardIos,
  Cancel,
  DeleteOutline,
  Edit,
  Visibility,
} from "@mui/icons-material";
import axios from "axios";
import DeleteModal from "../../components/Modals/DeleteModal";
import { toast } from "react-toastify";
import NotFound from "../../components/SharedModule/NotFound";
import CheckIcon from "@mui/icons-material/Check";
import AddIcon from "@mui/icons-material/Add";
import { useSelector } from "react-redux";
import { Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";

export default function Templates() {
  const location = useLocation();

  const { user } = useSelector((state) => state.auth);

  const token = user?.token;

  const newBaseUrl = "https://estbn.com/EstbnNew/public";

  const headers = {
    Authorization: "Bearer " + token,
  };

  const navigate = useNavigate();

  // **************** create template functions ******************

  const [show, setShow] = useState(false);

  const handleShow = () => {
    setAddMainCatigory({
      image: "",
      body: "",
      title: "",
      name: "",
      code: "",
      category_id: "",
      status: "",
      variables: [{ id: Date.now(), key: "", value: "" }],
    });
    setShow(true);
  };

  const handleClose = () => {
    setAddMainCatigory({
      image: "",
      fileUrl: "",
      name: "",
      code: "",
      title: "",
      body: "",
      category_id: "",
      status: "",
      variables: [{ id: Date.now(), key: "", value: "" }],
    });
    setShow(false);
    setStep(1);
    setEditTemplateId(null);
  };

  //  (variables)

  const handleAddVariable = () => {
    setAddMainCatigory((prev) => ({
      ...prev,
      variables: [...prev.variables, { id: Date.now(), key: "", value: "" }],
    }));
  };

  const handleRemoveVariable = (id) => {
    setAddMainCatigory((prev) => ({
      ...prev,
      variables: prev.variables.filter((v) => v.id !== id),
    }));
  };

  const handleVariableChange = (id, field, fieldValue) => {
    setAddMainCatigory((prev) => ({
      ...prev,
      variables: prev.variables.map((v) =>
        v.id === id ? { ...v, [field]: fieldValue } : v
      ),
    }));
  };

  // (steps)

  const [step, setStep] = useState(1);

  const handleNext = () => {
    if (step < 3) setStep(step + 1);
    else {
      return;
    }
  };

  const handleBack = () => {
    if (step > 1) setStep(step - 1);
  };

  const renderStepCircle = (stepNumber, label) => {
    let circleClass = "step-circle";
    let textClass = "step-label";
    let content = <p className="my-0 fw-semibold fs-5">{stepNumber}</p>;

    if (stepNumber < step) {
      circleClass += " step-success";
      content = <CheckIcon style={{ color: "white" }} />;
    } else if (stepNumber === step) {
      circleClass += " step-active";
    } else {
      circleClass += " step-muted";
      textClass += " muted-text";
    }

    return (
      <div className="d-flex flex-column justify-content-between align-items-center w-25">
        <div className={circleClass}>{content}</div>
        <div className="my-2">
          <p className={`my-0 fw-semibold ${textClass}`}>{label}</p>
        </div>
      </div>
    );
  };

  // (translations)

  const [translations, setTranslations] = useState([
    {
      id: Date.now(),
      languageCode: "",
      title: "",
      body: "",
    },
  ]);

  const handleAddTranslation = () => {
    setTranslations([
      ...translations,
      {
        id: Date.now() + Math.random(),
        languageCode: "",
        title: "",
        body: "",
      },
    ]);
  };

  const handleRemoveTranslation = (id) => {
    setTranslations(translations.filter((t) => t.id !== id));
  };

  const handleTranslationChange = (id, field, value) => {
    setTranslations(
      translations.map((t) => (t.id === id ? { ...t, [field]: value } : t))
    );
  };

  // (variants)

  const [variants, setVariants] = useState([
    {
      id: Date.now(),
      title: "",
      body: "",
    },
  ]);

  const handleAddVariant = () => {
    setVariants([
      ...variants,
      {
        id: Date.now() + Math.random(),
        title: "",
        body: "",
      },
    ]);
  };

  const handleRemoveVariant = (id) => {
    setVariants(variants.filter((v) => v.id !== id));
  };

  const handleChangeVariants = (id, field, value) => {
    setVariants(
      variants.map((v) => (v.id === id ? { ...v, [field]: value } : v))
    );
  };

  //  sumbit & edit functions

  const [editTemplateId, setEditTemplateId] = useState(null);

  const handleEditTemplate = async (temId) => {
    try {
      const response = await axios.get(
        `${newBaseUrl}/api/portal/notification-templates/${temId}`,
        {
          headers,
        }
      );

      setAddMainCatigory({
        image: "",
        fileUrl: response.data.data.template.image_url
          ? response.data.data.template.image_url.startsWith("http")
            ? response.data.data.template.image_url
            : `${newBaseUrl}/${response.data.data.template.image_url}`
          : "",
        name: response.data.data.template.name || "",
        code: response.data.data.template.code || "",
        title: response.data.data.template.title || "",
        body: response.data.data.template.body || "",
        category_id: response.data.data.template.category?.id || "",
        status: response.data.data.template.status || "",
        variables: response.data.data.template.variables
          ? Object.entries(response.data.data.template.variables).map(
              ([key, value]) => ({
                id: Date.now() + Math.random(),
                key,
                value,
              })
            )
          : [],
      });

      setValue("name", response.data.data.template.name || "");
      setValue("code", response.data.data.template.code || "");
      setValue("title", response.data.data.template.title || "");
      setValue("body", response.data.data.template.body || "");
      setValue("category_id", response.data.data.template.category?.id || "");
      setValue("status", response.data.data.template.status || "");

      setEditTemplateId(temId);
      setShow(true);
    } catch (error) {
      toast.error("Failed to load template data");
      console.error(error);
      return null;
    }
  };

  const [addMainCatigory, setAddMainCatigory] = useState({
    image: "",
    fileUrl: "",
    body: "",
    title: "",
    name: "",
    code: "",
    category_id: "",
    status: "",
    variables: [{ id: Date.now(), key: "", value: "" }],
  });

  const [functionCategories, setFunctionCategories] = useState([]);

  const getFuncCategories = async () => {
    try {
      let response = await axios.get(
        `${newBaseUrl}/api/portal/notification-categories`,
        { headers }
      );
      console.log(response.data.data.categories);
      setFunctionCategories(response.data.data.categories);
    } catch (error) {
      console.log(error);
    }
  };

  const [templateStatuses, setTemplateStatuses] = useState([]);

  const getTemplateStatuses = async () => {
    try {
      let response = await axios.get(
        `${newBaseUrl}/api/portal/notification-templates/statuses`,
        { headers }
      );
      console.log(response.data.data.template_statuses);
      setTemplateStatuses(response.data.data.template_statuses);
    } catch (error) {
      console.log(error);
    }
  };

  const handleSubmitTemplate = async () => {
    const formData = new FormData();

    if (editTemplateId) {
      formData.append("_method", "PUT");
    }

    formData.append("name", addMainCatigory.name);
    formData.append("code", addMainCatigory.code);
    formData.append("title", addMainCatigory.title);
    formData.append("body", addMainCatigory.body || "");
    formData.append("status", addMainCatigory.status);
    formData.append("category_id", addMainCatigory.category_id);

    if (addMainCatigory.image) {
      formData.append("image", addMainCatigory.image);
    }

    if (addMainCatigory.variables) {
      addMainCatigory.variables.forEach((v) => {
        if (v.key.trim()) {
          formData.append(`variables[${v.key}]`, v.value);
        }
      });
    }

    const url = editTemplateId
      ? `${newBaseUrl}/api/portal/notification-templates/${editTemplateId}`
      : `${newBaseUrl}/api/portal/notification-templates`;

    try {
      const response = await axios.post(url, formData, { headers });
      console.log(response);
      toast.success(response.data.data.message, { autoClose: 3000 });
      handleClose();
      getTemplates();
    } catch (error) {
      console.error(error);
      toast.error(error.response.data.message, { autoClose: 3000 });
    }
  };

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors, isSubmitting },
  } = useForm();

  // *********************** Template data table ***************************

  const [templates, setTemplates] = useState({
    templates: [],
    current_page: 1,
    last_page: 1,
    next_page_url: null,
    prev_page_url: null,
  });

  const [searchTerm, setSearchTerm] = useState("");

  const [selectedTemplates, setSelectedTemplates] = useState([]);

  const [showFilterDropdown, setShowFilterDropdown] = useState(false);

  const [categories, setCategories] = useState([]);

  const getTemplates = async () => {
    try {
      let response = await axios.get(
        `${newBaseUrl}/api/portal/notification-templates`,
        { headers }
      );
      console.log(response.data.data);
      setTemplates(response.data.data);
    } catch (error) {
      console.log(error);
    }
  };

  const columns = [
    {
      field: "Code",
      headerName: "Code",
      flex: 0.8,
      minWidth: 100,
    },
    {
      field: "Name",
      headerName: "Name",
      flex: 1,
      minWidth: 120,
    },
    {
      field: "Category",
      headerName: "Category",
      flex: 1,
      minWidth: 120,
    },
    {
      field: "Status",
      headerName: "Status",
      flex: 0.7,
      minWidth: 70,
    },
    {
      field: "Created",
      headerName: "Created By",
      flex: 1,
      minWidth: 100,
    },
    {
      field: "Actions",
      headerName: "Actions",
      flex: 1,
      minWidth: 125,
      renderCell: (params) => {
        const handleEdit = async (e) => {
          e.stopPropagation();
          handleEditTemplate(params.row.id);
        };
        const handleDelete = (event) => {
          event.stopPropagation();
          confirmDelete(params.row.id);
        };
        const handleNavigate = (event) => {
          event.stopPropagation();
          navigate(`/Templates/${params.row.id}`);
        };
        const handlePreview = (event) => {
          event.stopPropagation();
          handleShowPreview();
        };
        return (
          <div
            style={{
              display: "flex",
              justifyContent: "space-evenly",
              alignItems: "center",
              height: "100%",
              width: "100%",
            }}
          >
            <IconButton
              onClick={handlePreview}
              color="default"
              style={{ width: "22%" }}
              aria-label="edit"
            >
              <Visibility />
            </IconButton>
            <IconButton
              onClick={handleEdit}
              color="default"
              style={{ width: "22%" }}
              aria-label="edit"
            >
              <Edit />
            </IconButton>
            <IconButton
              onClick={handleDelete}
              color="error"
              style={{ width: "22%" }}
              aria-label="delete"
            >
              <DeleteOutline />
            </IconButton>
            <IconButton
              onClick={handleNavigate}
              color="default"
              style={{ width: "22%" }}
              aria-label="edit"
            >
              <ArrowForwardIos />
            </IconButton>
          </div>
        );
      },
    },
  ];

  const paginationModel = { page: 0, pageSize: 10 };

  const filteredRows = templates.templates
    .filter((template) => {
      const matchesSearch =
        template.code.toLowerCase().includes(searchTerm.toLowerCase()) ||
        template.name.toLowerCase().includes(searchTerm.toLowerCase());

      const templateCategoryName = template.category.name || "";

      const matchesCategory =
        selectedTemplates.length === 0 ||
        selectedTemplates.includes(templateCategoryName);
      return matchesSearch && matchesCategory;
    })
    .map((template) => ({
      id: template.id,
      Code: template.code,
      Name: template.name,
      Category: template.category?.name,
      Status: template.status,
      Created: template.creator?.name,
      Actions: "",
      rawData: template,
    }));

  // ****************************** delete template *************************

  const [templateId, setTemplateId] = useState(null);

  const [showDelete, setShowDelete] = useState(false);

  const confirmDelete = (id) => {
    setShowDelete(true);
    setTemplateId(id);
  };

  const handleDeleteClose = () => {
    setShowDelete(false);
    setTemplateId(null);
  };

  const deleteTemplate = async () => {
    try {
      let response = await axios.delete(
        `${newBaseUrl}/api/portal/notification-templates/${templateId}`,
        {
          headers,
        }
      );
      toast.warning("Template Deleted successfully", { autoClose: 3000 });
      console.log(response);
      handleDeleteClose();
      getTemplates();
    } catch (error) {
      toast.error("Failed To Delete This Template.");
      console.log(error.message);
    }
  };

  // ******************************* preview template ***************************

  const [showPreview, setShowPreview] = useState(false);

  const handleShowPreview = () => {
    setShowPreview(true);
  };

  const handleClosePreview = () => {
    setShowPreview(false);
  };

  // ******************************* effects ************************************

  useEffect(() => {
    if (location.state?.openModal) {
      handleShow();
    }
  }, [location.state]);

  useEffect(() => {
    const allCategoryNames = templates.templates
      .flatMap((offer) => offer?.category?.name)
      .filter(Boolean);

    const uniqueCategories = [...new Set(allCategoryNames)];
    setCategories(uniqueCategories);
  }, [templates]);

  useEffect(() => {
    getTemplates();
    getFuncCategories();
    getTemplateStatuses();
  }, []);

  return (
    <>
      {/* delete template  */}
      <DeleteModal
        showDelete={showDelete}
        handleDeleteClose={handleDeleteClose}
        textMessage={" Are you sure you want to delete this Template?"}
        deleteFunction={deleteTemplate}
      />
      {/* add template  */}
      <Modal show={show} onHide={handleClose}>
        <Modal.Header className="categories_header">
          <Modal.Title className="categories_title d-flex justify-content-between align-items-center">
            <p className=" my-0 small">
              {editTemplateId
                ? "Edit Notification Template"
                : "Create New Notification Template"}
            </p>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* steps  */}
          <div className="d-flex justify-content-evenly align-items-center my-4">
            {renderStepCircle(1, "Basic Info")}
            {renderStepCircle(2, "Content")}
            {renderStepCircle(3, "Advanced")}
          </div>
          {/* form  */}
          <form onSubmit={handleSubmit(handleSubmitTemplate)}>
            {/* step 1 data  */}
            {step === 1 && (
              <>
                <p className=" fw-semibold fs-5 mt-4 mb-3">Basic Info</p>
                {/* name & code */}
                <div className="row">
                  {/* name  */}
                  <div className="col-6">
                    <TextField
                      className="w-100 mb-4"
                      label="Name"
                      variant="outlined"
                      {...register("name")}
                      value={addMainCatigory.name}
                      onChange={(e) => {
                        setAddMainCatigory({
                          ...addMainCatigory,
                          name: e.target.value,
                        });
                      }}
                    />
                    {errors.name && (
                      <p className="danger">{errors.name.message}</p>
                    )}
                  </div>
                  {/* code  */}
                  <div className="col-6">
                    <TextField
                      className="w-100 mb-4"
                      label="Code"
                      variant="outlined"
                      {...register("code")}
                      value={addMainCatigory.code}
                      onChange={(e) => {
                        setAddMainCatigory({
                          ...addMainCatigory,
                          code: e.target.value,
                        });
                      }}
                    />
                    {errors.code && (
                      <p className="danger">{errors.code.message}</p>
                    )}
                  </div>
                </div>
                {/* category & status */}
                <div className="row">
                  {/* category */}
                  <div className="col-6">
                    <FormControl className="w-100 mb-4" variant="outlined">
                      <InputLabel id="category-label">Category</InputLabel>
                      <Select
                        labelId="category-label"
                        label="Category"
                        {...register("category_id")}
                        value={addMainCatigory.category_id}
                        onChange={(e) => {
                          setAddMainCatigory({
                            ...addMainCatigory,
                            category_id: e.target.value,
                          });
                        }}
                      >
                        {functionCategories.map((cat) => (
                          <MenuItem className="custom-menu-item" value={cat.id}>
                            {cat.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    {errors.category_id && (
                      <p className="danger">{errors.category_id.message}</p>
                    )}
                  </div>
                  {/* status  */}
                  <div className="col-6">
                    <FormControl className="w-100 mb-4" variant="outlined">
                      <InputLabel id="status-label">Status</InputLabel>
                      <Select
                        labelId="status-label"
                        label="Status"
                        {...register("status")}
                        value={addMainCatigory.status}
                        onChange={(e) => {
                          setAddMainCatigory({
                            ...addMainCatigory,
                            status: e.target.value,
                          });
                        }}
                      >
                        {templateStatuses.map((status) => (
                          <MenuItem
                            className="custom-menu-item"
                            value={status.value}
                          >
                            {status.key}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    {errors.status && (
                      <p className="danger">{errors.status.message}</p>
                    )}
                  </div>
                </div>
              </>
            )}
            {/* step 2 data  */}
            {step === 2 && (
              <>
                <p className=" fw-semibold fs-5 mt-4 mb-3">Content</p>
                {/* image  */}
                <div className="w-100 my-3">
                  <input
                    type="file"
                    accept="image/*"
                    id="icon_url"
                    style={{ display: "none" }}
                    {...register("image")}
                    onChange={(e) => {
                      const file = e.target.files[0];
                      if (file) {
                        const allowedTypes = [
                          "image/jpeg",
                          "image/png",
                          "image/jpg",
                          "image/gif",
                          "image/svg+xml",
                        ];
                        if (allowedTypes.includes(file.type)) {
                          const imageUrl = URL.createObjectURL(file);
                          setAddMainCatigory({
                            ...addMainCatigory,
                            image: file,
                            fileUrl: imageUrl,
                          });
                        } else {
                          toast.error(
                            "Please select a valid image file (jpeg, png, jpg, gif, svg)."
                          );
                          setAddMainCatigory({
                            ...addMainCatigory,
                            image: "",
                            fileUrl: "",
                          });
                        }
                      }
                    }}
                  />
                  <label htmlFor="" className="mb-2">
                    Template image
                  </label>
                  <div
                    className="image-uploadd-container d-flex py-3 px-4 justify-content-between 
                    align-items-center  w-100"
                  >
                    {/* Image on the left */}
                    <div className="upload-container">
                      <img
                        src={addMainCatigory.fileUrl || AddPhoto}
                        alt="Selected"
                        className="uploaded-image"
                      />
                    </div>
                    {/* Button on the right */}
                    <button
                      type="button"
                      className="btn btn-outline-dark px-4"
                      onClick={() =>
                        document.getElementById("icon_url").click()
                      }
                    >
                      Browse
                    </button>
                  </div>
                  {errors.image && (
                    <p className="danger mt-2">{errors.image.message}</p>
                  )}
                </div>
                {/* title */}
                <div className="w-100">
                  <label htmlFor="" className="mb-2">
                    Title
                  </label>
                  <TextField
                    className="w-100"
                    placeholder="Add Title"
                    variant="outlined"
                    {...register("title")}
                    value={addMainCatigory.title}
                    onChange={(e) => {
                      setAddMainCatigory({
                        ...addMainCatigory,
                        title: e.target.value,
                      });
                    }}
                  />
                  {errors.title && (
                    <p className="danger">{errors.title.message}</p>
                  )}
                </div>
                {/* content  */}
                <div className="w-100">
                  <label htmlFor="" className="mb-2">
                    Template Content
                  </label>
                  <TextField
                    className="w-100"
                    placeholder="Enter Notification Body Content "
                    variant="outlined"
                    rows={4}
                    multiline
                    {...register("body")}
                    value={addMainCatigory.body}
                    onChange={(e) => {
                      setAddMainCatigory({
                        ...addMainCatigory,
                        body: e.target.value,
                      });
                    }}
                  />
                  {errors.body && (
                    <p className="danger">{errors.body.message}</p>
                  )}
                </div>
                {/* variables */}
                <div>
                  <label htmlFor="" className="mb-2">
                    Variables
                  </label>
                  {addMainCatigory.variables?.map((v, index) => (
                    <div
                      key={v.id}
                      className="d-flex align-items-center mb-2 gap-2"
                    >
                      <TextField
                        label="Variable"
                        variant="outlined"
                        value={v.key}
                        onChange={(e) =>
                          handleVariableChange(v.id, "key", e.target.value)
                        }
                        size="small"
                        className="flex-grow-1"
                      />
                      <TextField
                        label="Value"
                        variant="outlined"
                        value={v.value}
                        onChange={(e) =>
                          handleVariableChange(v.id, "value", e.target.value)
                        }
                        size="small"
                        className="flex-grow-1"
                      />
                      <IconButton
                        color="error"
                        className="mb-4"
                        onClick={() => handleRemoveVariable(v.id)}
                      >
                        <DeleteOutline />
                      </IconButton>
                    </div>
                  ))}
                  <div className="text-end">
                    <Button
                      variant="contained"
                      color="black"
                      startIcon={<AddIcon />}
                      onClick={handleAddVariable}
                    >
                      Add variable
                    </Button>
                  </div>
                </div>
              </>
            )}
            {/* step 3 data  */}
            {step === 3 && (
              <>
                <p className=" fw-semibold fs-5 mt-4 mb-3">Advanced Settings</p>
                {/* Default Data (JSON) */}
                <div className="w-100 mt-3">
                  <label htmlFor="" className="mb-2">
                    Default Data (JSON)
                  </label>
                  <TextField
                    className="w-100"
                    label="Enter Default Data (JSON)"
                    variant="outlined"
                    rows={4}
                    multiline
                    {...register("content")}
                    value={addMainCatigory.content}
                    onChange={(e) => {
                      setAddMainCatigory({
                        ...addMainCatigory,
                        content: e.target.value,
                      });
                    }}
                  />
                  {errors.content && (
                    <p className="danger">{errors.content.message}</p>
                  )}
                </div>
                {/* translations */}
                <div>
                  <label htmlFor="" className=" mb-2">
                    Translations
                  </label>
                  {translations.map((t, index) => (
                    <div
                      key={t.id}
                      className=" border border-1 rounded-3 px-3 pt-4 mb-3"
                      style={{ borderColor: "#ccc" }}
                    >
                      {/* Language Code with delete */}
                      <div
                        className="d-flex align-items-center"
                        style={{ gap: "8px" }}
                      >
                        <TextField
                          label="Language Code"
                          variant="outlined"
                          size="small"
                          className="flex-grow-1"
                          value={t.languageCode}
                          onChange={(e) =>
                            handleTranslationChange(
                              t.id,
                              "languageCode",
                              e.target.value
                            )
                          }
                        />
                        <IconButton
                          color="error"
                          onClick={() => handleRemoveTranslation(t.id)}
                          size="small"
                          className=" mb-4"
                        >
                          <DeleteOutline />
                        </IconButton>
                      </div>
                      {/* Translated Title */}
                      <TextField
                        label="Translated Title"
                        variant="outlined"
                        size="small"
                        fullWidth
                        className="mb-3"
                        value={t.title}
                        onChange={(e) =>
                          handleTranslationChange(t.id, "title", e.target.value)
                        }
                      />
                      {/* Translated Body */}
                      <TextField
                        label="Translated Body"
                        variant="outlined"
                        size="small"
                        fullWidth
                        value={t.body}
                        onChange={(e) =>
                          handleTranslationChange(t.id, "body", e.target.value)
                        }
                      />
                    </div>
                  ))}
                  <div className=" text-end my-4">
                    <Button
                      variant="contained"
                      color="dark"
                      startIcon={<AddIcon />}
                      onClick={handleAddTranslation}
                    >
                      Add Translation
                    </Button>
                  </div>
                </div>
                {/* variants */}
                <div>
                  <label htmlFor="" className=" mb-2">
                    A/B Test Variants
                  </label>
                  {variants.map((v, index) => (
                    <div
                      key={v.id}
                      className=" border border-1 rounded-3 px-3 pt-4 mb-3"
                      style={{ borderColor: "#ccc" }}
                    >
                      {/* Title with delete icon */}
                      <div
                        className="d-flex align-items-center"
                        style={{ gap: "8px" }}
                      >
                        <TextField
                          label="Variant Title"
                          variant="outlined"
                          size="small"
                          className="flex-grow-1"
                          value={v.title}
                          onChange={(e) =>
                            handleChangeVariants(v.id, "title", e.target.value)
                          }
                        />
                        <IconButton
                          color="error"
                          onClick={() => handleRemoveVariant(v.id)}
                          size="small"
                          className=" mb-4"
                        >
                          <DeleteOutline />
                        </IconButton>
                      </div>
                      {/* Body */}
                      <TextField
                        label="Variant Body"
                        variant="outlined"
                        size="small"
                        fullWidth
                        value={v.body}
                        onChange={(e) =>
                          handleChangeVariants(v.id, "body", e.target.value)
                        }
                      />
                    </div>
                  ))}
                  <div className=" text-end my-4">
                    <Button
                      variant="contained"
                      color="dark"
                      startIcon={<AddIcon />}
                      onClick={handleAddVariant}
                    >
                      Add Variant
                    </Button>
                  </div>
                </div>
              </>
            )}
            {/* footer  */}
            <div className="categories_foterAddModel d-flex justify-content-evenly align-items-center mt-5">
              <button
                type="button"
                className="categories_closAddModal"
                onClick={handleClose}
              >
                Cancel
              </button>
              <div>
                {step > 1 && (
                  <button
                    type="button"
                    className="me-2 btn btn-secondary"
                    onClick={handleBack}
                  >
                    Back
                  </button>
                )}
                <button
                  type="button"
                  className="categories_saveAddModeal"
                  disabled={isSubmitting}
                  onClick={
                    step === 3 ? handleSubmit(handleSubmitTemplate) : handleNext
                  }
                >
                  {step === 3 ? "Save" : "Next"}
                </button>
              </div>
            </div>
          </form>
        </Modal.Body>
      </Modal>
      {/* preview template  */}
      <Modal show={showPreview} onHide={handleClosePreview}>
        <Modal.Header className="categories_header">
          <Modal.Title className="categories_title d-flex justify-content-between align-items-center">
            <p className=" my-0 small">Template Preview</p>
            <div className=" cursor" onClick={handleClosePreview}>
              <Cancel />
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className=" border border-1 rounded-3 p-3">
            <p className=" fw-semibold mb-2">Welcome Email</p>
            <p className=" text-muted small my-2">Hello {"user_name"}</p>
            <p className=" text-muted small my-2">
              Welcome to our platform! We're excited to have you on board.
            </p>
            <p className=" text-muted mb-0 small">Best regards,</p>
            <p className=" text-muted my-0 small">The Team</p>
            <hr />
            <p className=" fw-semibold mb-2">Variables used</p>
            <p className=" text-muted small my-2">User_name</p>
            <p className=" text-muted small my-1">Omar Ali</p>
          </div>
        </Modal.Body>
      </Modal>
      {/* offers data  */}
      <div className="m-4">
        {/* offers head  */}
        <div className="notifications-display d-flex justify-content-between align-items-center">
          <p className="my-sm-2 fs-5 my-md-0 fw-bold">Notification Templates</p>
          <button
            onClick={handleShow}
            className="btn border border-1 text-muted p-2"
          >
            <i className="fa-solid fa-plus fw-light mx-1"></i>
            Add New Template
          </button>
        </div>
        {/* offers search  */}
        <div className="notif-search d-flex justify-content-center justify-content-md-end align-items-center my-3">
          {/* text search  */}
          <FormControl
            sx={{ width: "40ch" }}
            className="me-3 mx-md-3"
            variant="outlined"
          >
            <InputLabel htmlFor="outlined-adornment-password">
              Search by Code, name ..
            </InputLabel>
            <OutlinedInput
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              id="outlined-adornment-password"
              type={"text"}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton edge="end">{<SearchIcon />}</IconButton>
                </InputAdornment>
              }
              label="Search by Code, name, type..."
            />
          </FormControl>
          {/* filteration  */}
          <div className="position-relative border border-1 p-2 mb-3 rounded-3">
            <IconButton onClick={() => setShowFilterDropdown((prev) => !prev)}>
              <FilterListIcon />
            </IconButton>
            {showFilterDropdown && (
              <div
                className="position-absolute mt-2 rounded shadow"
                style={{
                  width: "240px",
                  right: 0,
                  backgroundColor: "#fff",
                  border: "1px solid #ddd",
                  padding: "16px",
                  zIndex: 10,
                }}
              >
                <p className="fw-bold mb-2">Filter by Category</p>
                <div style={{ maxHeight: "200px", overflowY: "auto" }}>
                  {categories.map((cat) => (
                    <label
                      key={cat}
                      className="d-flex align-items-center mb-2"
                      style={{
                        cursor: "pointer",
                        fontSize: "14px",
                        gap: "8px",
                      }}
                    >
                      <input
                        type="checkbox"
                        checked={selectedTemplates.includes(cat)}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setSelectedTemplates((prev) => [...prev, cat]);
                          } else {
                            setSelectedTemplates((prev) =>
                              prev.filter((c) => c !== cat)
                            );
                          }
                        }}
                      />
                      <span>{cat}</span>
                    </label>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
        {/* offers table  */}
        <div>
          {filteredRows && filteredRows.length > 0 ? (
            <div className="scrollable-table-wrapper">
              <div>
                <Paper sx={{ width: "100%" }}>
                  <DataGrid
                    rows={filteredRows}
                    columns={columns}
                    initialState={{ pagination: { paginationModel } }}
                    pageSizeOptions={[5, 10]}
                    checkboxSelection
                    sx={{ border: 0 }}
                    slotProps={{
                      pagination: {
                        sx: {
                          justifyContent: "center",
                          display: "flex",
                          alignItems: "center",
                        },
                      },
                    }}
                  />
                </Paper>
              </div>
            </div>
          ) : (
            <div
              className="d-flex justify-content-center align-items-center w-100"
              style={{ minHeight: "300px" }}
            >
              <NotFound
                paragraphText={
                  "No Offers Yet. All your Offers will appear here once you get started."
                }
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
}
